export default __webpack_public_path__ + "07fb8de38edf149578943becb30e842c.svg";